import { styled, useTheme } from 'styled-components';
import CheckMark from 'assets/images/checkmark.svg';
import useRegistrationContext from '../../context/NewRegistrationModalContext';
import { Image } from '../../../../../Base/Image';

const StepperWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 50px;
  position: relative;

  @media (max-width: 768px) {
    position: sticky;
    top: -24px;
    margin-right: 0;
    margin-top: -24px;
    background: white;
    padding-top: 12px;
    z-index: 10;
  }
`;

const StepNumberWrapper = styled.div<{ $isMobileCurrent?: boolean }>`
  padding: 8px;
  background: white;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    display: ${props => (props.$isMobileCurrent ? 'flex' : 'none')};
    align-items: center;
    gap: 8px;
  }
`;

const StepperMiddleLine = styled.hr<{ theme: any }>`
  border-top: 2px solid ${props => props.theme.colorBlackGrey50};
  position: absolute;
  width: 100%;
  top: 16px;
  z-index: 1;

  @media (max-width: 768px) {
    display: none;
  }
`;

const StepNumber = styled.div<{
  $active: boolean;
  $done: boolean;
  theme: any;
}>`
  border: 2px solid ${props => props.theme.colorBlackGrey50};
  color: ${props => props.theme.colorBlackGrey50};
  font-weight: 600;
  border-radius: 90px;
  font-family: Montserrat, sans-serif;
  height: 32px;
  width: 32px;
  position: relative;

  span {
    font-size: 16px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  img {
    margin-left: 5px;
    margin-top: 4px;
  }

  ${props =>
    props.$active &&
    `
      background: ${props.theme.buttonColorPrimaryNormalBg};
      border-color: ${props.theme.buttonColorPrimaryNormalBg};
      color: white;
    `}

  ${props =>
    props.$done &&
    `
      background: ${props.theme.inputColorBackgroundDisabled};
      border-color: ${props.theme.buttonColorPrimaryNormalBg};
    `}
`;

const StepText = styled.span<{ theme: any }>`
  display: none;
  @media (max-width: 768px) {
    display: block;
    color: black;
    font-weight: 400;
    font-size: 14px;
  }
`;

const ProgressStepper = () => {
  const theme = useTheme();
  const { stepper } = useRegistrationContext();

  return (
    <StepperWrapper>
      {[1, 2, 3].map(step => (
        <StepNumberWrapper key={step} $isMobileCurrent={stepper === step}>
          <StepNumber
            theme={theme}
            $active={stepper === step}
            $done={stepper > step}
          >
            {stepper > step ? (
              <Image alt="/" src={CheckMark} />
            ) : (
              <span>{step}</span>
            )}
          </StepNumber>
          <StepText theme={theme}>Step {step} of 3</StepText>
        </StepNumberWrapper>
      ))}
      <StepperMiddleLine theme={theme} />
    </StepperWrapper>
  );
};

export default ProgressStepper;
